const GraphReducer = (state = { tuple: null, visible: false }, action) => {
    switch (action.type) {
        case 'SET_MAIN_GRAPH':
            return action.payload === null
                ? { tuple: null, visible: false }
                : { ...state, tuple: action.payload };
        case 'SHOW_MAIN_GRAPH':
            return { ...state, visible: true };
        case 'HIDE_MAIN_GRAPH':
            return { ...state, visible: false };
        default:
            return state;
    }
}

export default GraphReducer;